export const STD_FIELDS_ENTITY = [
  'address1',
  'address2',
  'city',
  'contact_number',
  'country',
  'date_of_birth',
  'email',
  'first_name',
  'gender',
  'language',
  'last_name',
  'preferred_language',
  'zipcode',
];
